module.exports = __webpack_public_path__ + "media/images/smoke-0cabdc65d099d1be4c76be4a5b33584f.png";